export type TypographyName =
  | 'LargeTitle'
  | 'Title'
  | 'Subtitle3'
  | 'Subtitle1'
  | 'Subtitle2'
  | 'LargeBody'
  | 'LargeBodyBold'
  | 'SmallBody'
  | 'SmallBodyBold'
  | 'Caption'
  | 'CaptionBold';

export const typography: Record<TypographyName, string> = {
  LargeTitle: 'text-h2mob lg:text-h2 font-title',
  Title: 'text-h3mob lg:text-h3 font-title',
  // H3Subtitle: 'text-h3mob lg:text-subtitlelarge font-title',
  Subtitle1: 'text-subtitlesmall lg:text-subtitlelarge font-title',
  Subtitle2: 'text-subtitlesmallmob lg:text-subtitlesmall font-semibold',
  Subtitle3: 'text-largebodymob font-title',
  LargeBody: 'text-largebodymob lg:text-largebody font-body',
  LargeBodyBold: 'text-largebodymob lg:text-largebody font-semibold',
  SmallBody: 'text-smallbodymob lg:text-smallbody font-body',
  SmallBodyBold: 'text-smallbodymob lg:text-smallbody font-semibold',
  Caption: 'text-caption font-body',
  CaptionBold: 'text-caption font-semibold',
};
